import React, {useContext, useEffect, useRef, useState} from 'react';
import {LogsContext} from "./logsContext";
import {BarCodeScannerContext} from "../../../contexts/barCodeScannerContext";
import {launchOmniScan} from "../../../api/wms/omiScan";
import {WMSContext} from "../context/WMSContext";
import {Grid, TextField} from "@mui/material";
import CustomButton from "../../../components/CustomButton";
import WmsMobileLayout from "../wmsMobileLayout";
import {FormattedMessage, useIntl} from "react-intl";
import {greyishBlue500} from "../../../assets/jss/main";
import ItemList from "./components/itemList";
import ItemLogSearch from "./components/itemLogSearch";
import {useHistory, useLocation} from "react-router-dom";
import {WMSRoutes} from "../../../utils/WMSRoutes";
import PageTitle from "../../../components/WMS/Mobile/PageTitle";
import Badge from "../../../components/Badge";
import ToggleNavigation from "../../../components/Toggle/ToggleNavigation";
import Toggle from "../../../components/Toggle/Toggle";
import Toast from "../../../components/WMS/Toast";
import RedWarning from "assets/img/redWarning.svg";

const TAB_TYPES = [null, 'item', 'container', 'shipment'];

function Logs() {
    const {currentInventory, isMobile} = useContext(WMSContext);
    const {scannedString, enableScan, setEnableScan, resetScannedString} = useContext(BarCodeScannerContext)
    const intl = useIntl();

    const [logsSearch, setLogsSearch] = useState(false)
    const [isManualSelection, setIsManualSelection] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [manualSearchTab, setManualSearchTab] = useState(0);
    const [manualSearchValue, setManualSearchValue] = useState('');
    const [openToast, setOpenToast] = useState(false);

    const location = useLocation()
    const history = useHistory();

    const itemType = useRef("");
    const itemId = useRef("");
    const selectedItemIdentifier = useRef("");
    const selectedItemBarcode = useRef("")

    function handleOmniScanResponse(response, selectedType) {
        if (Object.keys(response).length === 0) {
            setOpenToast(true)
            return
        }
        const type = selectedType ?? Object.keys(response)[0]
        if (response[type] && response[type].length > 0) {
            itemType.current = type
            setItemList(response[type])
        } else {
            setOpenToast(true)
        }
    }

    function seeItemLog() {
        setLogsSearch(true)
        history.push(`${WMSRoutes.LOGS}/${itemId.current}/${itemType.current}`)
    }

    function backToList() {
        setLogsSearch(false)
        history.push(WMSRoutes.LOGS)
    }

    function clearList() {
        setItemList([])
        setManualSearchValue('')
        itemType.current = ""
    }

    function launchManualSearch() {
        if (!currentInventory || !manualSearchValue.trim()) return

        launchOmniScan(manualSearchValue.trim(), currentInventory.id)
            .then((response) => handleOmniScanResponse(response, TAB_TYPES[manualSearchTab]))
    }

    useEffect(() => {
        if (currentInventory && scannedString && "string" === typeof scannedString && 0 < scannedString.length) {
            setEnableScan(false)
            launchOmniScan(scannedString, currentInventory.id)
                .then((response) => handleOmniScanResponse(response, null))
                .finally(() => {
                    setEnableScan(true)
                    resetScannedString()
                    setManualSearchValue('')
                    setManualSearchTab(0)
                })
        }
    }, [scannedString]);
    return (
        <LogsContext.Provider value={{
            itemType,
            itemId,
            selectedItemIdentifier,
            selectedItemBarcode,
            isManualSelection,
            itemList,
            setIsManualSelection,
            seeItemLog,
        }}>
            {openToast && (
                <Toast
                    icon={<img src={RedWarning} alt={"red-warning"} style={{width: '20px', height: '20px'}}/>}
                    title={<FormattedMessage id={"wms.omniScan.notFound"}/>}
                    open={openToast}
                    handleClose={() => setOpenToast(false)}
                />
            )}

            <WmsMobileLayout
                disableMargin={isMobile}
            >
                <WmsMobileLayout.Content
                    overflow="hidden"
                    customStyle={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Grid container sx={{padding: !isMobile ? '16px' : 0, }}>
                        <PageTitle
                            isDesktop={!isMobile}
                            title={<FormattedMessage id={logsSearch ? "wms.logs.title.log" : "wms.logs.title.scan"}/>}
                        />

                        {logsSearch && (
                            <Grid container direction={"column"} sx={{padding: '8px'}} alignItems={"center"}
                                  alignContent={"center"}>
                                <span style={{fontWeight: "bold"}}>
                                     <FormattedMessage id={`wms.logs.itemType.${itemType.current}`}/>
                                    {' — '}{selectedItemIdentifier.current}
                                </span>
                                <Badge color={"online"} rounded>
                                    {selectedItemBarcode.current}
                                </Badge>

                            </Grid>
                        )}

                        {!logsSearch && (
                            <Grid container direction={"column"} sx={{padding: '8px'}} gap={"12px"}>
                                <Grid container sx={{minWidth: 0, width: "100%", overflow: "auto"}}>
                                    <ToggleNavigation value={manualSearchTab} onChange={setManualSearchTab} withoutBackground fullWidth>
                                        <Toggle label={<FormattedMessage id={"wms.logs.manualSelection.toggle.scan"}/>} fullWidth/>
                                        <Toggle label={<FormattedMessage id={"wms.logs.itemType.item"}/>} fullWidth/>
                                        <Toggle label={<FormattedMessage id={"wms.logs.itemType.container"}/>} fullWidth/>
                                        <Toggle label={<FormattedMessage id={"wms.logs.itemType.shipment"}/>} fullWidth/>
                                    </ToggleNavigation>
                                </Grid>

                                <TextField
                                    fullWidth
                                    size={"small"}
                                    value={manualSearchValue}
                                    onChange={(e) => setManualSearchValue(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && launchManualSearch()}
                                    placeholder={intl.formatMessage({id: `wms.logs.manualSelection.placeholder.${TAB_TYPES[manualSearchTab] ?? 'scan'}`})}
                                />
                            </Grid>
                        )}
                    </Grid>

                    <Grid
                        container
                        direction={'column'}
                        justifyContent={"flex-start"}
                        flex={1}
                        sx={{overflowY: 'auto', minHeight: 0, flexWrap: 'nowrap'}}
                    >

                        {0 === itemType.current.length && !logsSearch && (
                            <Grid item sx={{padding: '8px', margin: "auto", color: greyishBlue500}}>
                                <FormattedMessage id={"wms.logs.waitingForScan"}/>
                            </Grid>
                        )}

                        {logsSearch && ( // Affichage des logs d'un item
                            <ItemLogSearch/>
                        )}

                        {!logsSearch && 0 < itemType.current.length && 0 < itemList.length && ( // Affichage d'une liste d'item
                            <ItemList/>
                        )}

                    </Grid>
                </WmsMobileLayout.Content>
                <WmsMobileLayout.Footer>
                    {!logsSearch && (
                        <Grid container flexWrap={"nowrap"} gap={"8px"} alignItems={"center"}>
                            <CustomButton fullWidth onClick={launchManualSearch} disabled={!manualSearchValue.trim()}>
                                <FormattedMessage id={"wms.logs.manualSelection"}/>
                            </CustomButton>

                            {itemList.length > 0 && (
                                <CustomButton onClick={clearList} sx={{flexShrink: 0, whiteSpace: 'nowrap'}}>
                                    <FormattedMessage id={"wms.logs.clearList"}/>
                                </CustomButton>
                            )}
                        </Grid>
                    )}
                    {logsSearch && (
                        <CustomButton fullWidth onClick={backToList}>
                            <FormattedMessage id={"wms.logs.backToList"}/>
                        </CustomButton>
                    )}
                </WmsMobileLayout.Footer>
            </WmsMobileLayout>
        </LogsContext.Provider>
    );
}

export default Logs;